module.exports = __webpack_public_path__ + "img/wiley-practice_planners_logo.fc740cf1.svg";